<template>
  <div>
    <QS-scroller-box>
      <!-- 应收信息 -->
    <shouldReceiptInfo
      ref="shouldReceiptInfoRef"
      :customer="customer"
      @uploading="uploading"
      @uploaded="uploaded"/>
      <!-- 应收款项 -->
    <receiptItem ref="receiptItemRef" :ids="ids" @setTableData="getTableData" @setCustomer="getCustomer"/>
    <!-- 钉钉审批异常弹窗 -->
    <approveValidateDialog
      ref="approveValidateDialogRef"
      :dingTalkShow="dingTalkShow"
      :sunbmitFun="submitData"
      :tableData="tableItems"
      @reloadClick="getDingTalkBtnShow"
    />
    <!-- 按钮区 -->
    <div slot="bottomAction">
      <el-button size="small" @click="back"> 取消 </el-button>
      <el-button :loading="oLoading.submitLoading"
        @click="addResult"
        type="primary" size="small"
        v-show="!dingTalkShow">
        提交
      </el-button>
      <el-button
        :loading="oLoading.submitLoading"
        @click="addResult"
        type="primary"
        size="small"
        v-show="dingTalkShow">提交钉钉审批</el-button>
    </div>
  </QS-scroller-box>
  </div>
</template>

<script>
import shouldReceiptInfo from './shouldReceiptInfo.vue'
import receiptItem from './receiptItem.vue'
import approveValidateDialog from './ApproveValidateDialog/index.vue'
import * as globalApi from '@/api/global'
import { addRecordReceivableSignCheck } from '@/api/domain/returnLease'

export default {
  inject: ['orderData'],
  components: { shouldReceiptInfo, receiptItem, approveValidateDialog },
  props: {
    ids: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      customer: {}, // 客户对象
      dingTalkShow: false,
      tableItems: [],
      oLoading: {
        submitLoading: false,
      },
    }
  },
  created() {
    // 获取收款项
    this.$store.dispatch('getPaymentMethods', { type: 'financeFeeType' })
    // 获取付款方式
    this.$store.dispatch('getPaymentMethods', { type: 'paymentType' })
    this.getDingTalkBtnShow()
  },
  methods: {
    getTableData(val) {
      this.tableItems = val
    },
    getCustomer(data) {
      this.customer = data
    },
    // 获取钉钉审批按钮开启
    getDingTalkBtnShow() {
      globalApi.getSubmitDingTalkShow({
        bizType: 1,
      }).then((res) => {
        const { code, data } = res
        if (code !== 1) return
        this.dingTalkShow = data
      })
    },
    back() {
      this.$emit('back')
    },
    addResult() {
      this.$refs.receiptItemRef.handleValidate().then(() => {
        this.$refs.shouldReceiptInfoRef.$refs.addFormData.validate(
          async (valid) => {
            if (!valid) return
            if (!this.dingTalkShow) {
              // 提交
              this.$refs.approveValidateDialogRef.receivableFilterReceivable()
            } else {
              // 钉钉审批
              await this.getDingTalkBtnShow()
              this.$refs.approveValidateDialogRef.sunbmitDdApprove()
            }
          },
        )
      })
    },
    async submitData(filterReceivableIdList = []) {
      const submitData = {
        ...this.setSubmitParams(),
        filterReceivableIdList,
      }
      try {
        const { code, data } = await addRecordReceivableSignCheck(submitData)
        if (code === 1 && data) {
          const msg = this.dingTalkShow ? '发起审批成功' : '提交成功！'
          this.$message.success(msg)
          this.back()
        }
      } catch (error) {
        console.log(error, 'addResult')
      }
    },
    // 设置提交参数
    setSubmitParams() {
      const tableData = this.tableItems
      const isValidTableData = tableData && tableData.length > 0
      const receivableOrderInfos = []
      if (isValidTableData) {
        tableData.forEach((item) => {
          receivableOrderInfos.push({
            ...item,
            receivableId: item.id,
          })
        })
      }
      const tempOrderData = {
        sourceOrderId: (isValidTableData && tableData[0].sourceOrderId) || '',
        sourceOrderType: (isValidTableData && tableData[0].sourceOrderType) || '',
      }
      const { addFormData } = this.$refs.shouldReceiptInfoRef
      const { amountTotal } = this.$refs.receiptItemRef
      const params = {
        ...addFormData,
        customerId: this.customer.customerId,
        customerType: this.customer.customerType,
        receivableOrderInfos,
        totalAmount: amountTotal,
        attachment: this.getUoloadCommonFileData(addFormData.attachment),
        previewId: this.previewId,
        approvalAccessModeType: this.dingTalkShow ? 2 : 1,
        receivableSourceType: 4, // 审批来源     4: '个人订单详情批量线下收款', 6: '企业租赁订单详情批量线下收款' 企业订单没有费用结算
      }
      // 新增订单收款
      Object.assign(params, tempOrderData)
      return params
    },
    // 附件上传中
    uploading() {
      this.oLoading.submitLoading = true
    },
    // 附件上传成功或者失败
    uploaded() {
      this.oLoading.submitLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
